var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extColors"},_vm._l((_vm.car.colors),function(color,index){return _c('div',{key:index},[(color.spot)?_c('img',{attrs:{"src":color.spot,"alt":""}}):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }